export const carnegieMap = new Map([
  [-2, 'Vocational/Technical'],
  [1, '2-year'],
  [2, '2-year'],
  [3, '2-year'],
  [4, '2-year'],
  [5, '2-year'],
  [6, '4-year'],
  [7, '4-year'],
  [8, '4-year'],
  [9, '4-year'],
  [10, '4-year'],
  [11, '4-year'],
  [12, '4-year'],
  [13, '4-year'],
  [14, '4-year'],
  [15, '4-year'],
  [16, '4-year'],
  [17, '4-year'],
  [18, 'Graduate'],
]);

export const carnegieGroups = new Map([
  ['2-year', [1, 2, 3, 4, 5]],
  ['4-year', [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]],
  ['Graduate', [18]],
  ['Vocational/Technical', [-2]],
]);
